import React, { PureComponent } from 'react';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import withStyles from '@material-ui/core/styles/withStyles';
import GitHubIcon from '@material-ui/icons/GitHub';
import styles from './Footer.style';
import profileImage from '../../assets/profile.png'
import DiscordIcon from '../../icons/DiscordIcon';

class Footer extends PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div className={classes.container}>
          <Avatar alt='Aware' src={profileImage} className={classes.avatar} />
          <Typography className={classes.text}>
            Aware
          </Typography>
        </div>
        <div className={classes.centerDiv} />
        <div className={classes.container}>
          <Tooltip title='Aware#9374' arrow enterTouchDelay={0}>
            <DiscordIcon className={classes.iconDiscord} />
          </Tooltip>
          <Link href='https://github.com/mraware'>
            <GitHubIcon className={classes.icon} />
          </Link>
        </div>
      </Paper>
    )
  }
}

export default withStyles(styles)(Footer)